import type { TabConfig } from '../common/types';
import type { IntakeTabId } from './types';

export const INTAKE_QUESTIONNAIRE_BASE_PATH = '/questionnaires/intake';
export const INTAKE_QUESTIONNAIRE_ROUTE_PATH = `${INTAKE_QUESTIONNAIRE_BASE_PATH}/:intakeQuestionnaireId/*`;

export const INTAKE_MONTH_YEAR_DISPLAY_FORMAT = 'MM/YY';

export const INTAKE_TAB_IDS = {
  INTRODUCTION: 'introduction',
  GENERAL: 'general',
  MEDICAL: 'medical',
  REFERRAL: 'referral',
  MEDICATION: 'medication',
  THERAPY: 'therapy',
  EDUCATION: 'education',
  FAMILY: 'family',
  CHILD: 'child',
  SUBMIT: 'submit',
} as const;

// Tabs whose validation schema must pass before the questionnaire can be concluded.
// Introduction and Submit carry no form of their own, so they're excluded.
export const CONCLUDE_REQUIRED_INTAKE_TAB_IDS: ReadonlyArray<IntakeTabId> = [
  INTAKE_TAB_IDS.GENERAL,
  INTAKE_TAB_IDS.MEDICAL,
  INTAKE_TAB_IDS.REFERRAL,
  INTAKE_TAB_IDS.MEDICATION,
  INTAKE_TAB_IDS.THERAPY,
  INTAKE_TAB_IDS.EDUCATION,
  INTAKE_TAB_IDS.FAMILY,
  INTAKE_TAB_IDS.CHILD,
];

export const INTAKE_TAB_CONFIGS: ReadonlyArray<TabConfig<IntakeTabId>> = [
  { id: INTAKE_TAB_IDS.INTRODUCTION, label: 'Introduction', path: INTAKE_TAB_IDS.INTRODUCTION },
  { id: INTAKE_TAB_IDS.GENERAL, label: 'General', path: INTAKE_TAB_IDS.GENERAL },
  { id: INTAKE_TAB_IDS.MEDICAL, label: 'Medical', path: INTAKE_TAB_IDS.MEDICAL },
  { id: INTAKE_TAB_IDS.REFERRAL, label: 'Referral', path: INTAKE_TAB_IDS.REFERRAL },
  { id: INTAKE_TAB_IDS.MEDICATION, label: 'Medication', path: INTAKE_TAB_IDS.MEDICATION },
  { id: INTAKE_TAB_IDS.THERAPY, label: 'Therapy', path: INTAKE_TAB_IDS.THERAPY },
  { id: INTAKE_TAB_IDS.EDUCATION, label: 'Education', path: INTAKE_TAB_IDS.EDUCATION },
  { id: INTAKE_TAB_IDS.FAMILY, label: 'Family', path: INTAKE_TAB_IDS.FAMILY },
  { id: INTAKE_TAB_IDS.CHILD, label: 'Child', path: INTAKE_TAB_IDS.CHILD },
  { id: INTAKE_TAB_IDS.SUBMIT, label: 'Submit', path: INTAKE_TAB_IDS.SUBMIT },
];
